import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import EditIcon from "images/icons/icon-edit.svg?raw"
import PlatformEditField from "partners/components/platform_edit_field/platform_edit_field"
import Modal from "shared/components/modal"
import { changeOrganizationOwner } from "../../../shared/lib/graphql"
import { updateOrgOwner } from "./actions"

export class OrgOwnerField extends Component {
  state = {
    modalOpen: false,
    selectedUser: this.props.orgOwner,
    modalButtonLoading: false,
  }

  setSelectedUser = user => {
    this.setState({
      selectedUser: user,
    })
  }

  changeOwner = () => {
    this.setState({ modalButtonLoading: true }, () => {
      changeOrganizationOwner(
        this.state.selectedUser.id.toString(),
        this.props.orgId.toString()
      )
        .then(owner => {
          this.props.dispatch(updateOrgOwner(owner))
          window.appendFlash("Organization owner has been updated", "success")
        })
        .catch(() => {
          this.setState({ modalButtonLoading: false }, () => {
            window.appendFlash(
              "An error has occurred, please contact customer support",
              "danger"
            )
          })
        })
        .then(() => {
          this.toggleOwnerModal()
        })
    })
  }

  renderModal = () => {
    const { orgOwner } = this.props
    return (
      <Modal
        includeCloseX={true}
        show={this.state.modalOpen}
        closeListener={this.toggleOwnerModal}
      >
        <>
          <h2>Select a member to transfer ownership to</h2>
          <section className="form-section">
            <PlatformEditField
              title={`${orgOwner.login} (${orgOwner.email})`}
              fieldCallback={() => {
                this.setSelectedUser(orgOwner)
              }}
            />

            {this.props.members.map((member, index) => {
              if (member.id != orgOwner.id) {
                return (
                  <PlatformEditField
                    key={index}
                    title={`${member.login} (${member.email})`}
                    fieldCallback={() => {
                      this.setSelectedUser(member)
                    }}
                  />
                )
              }
            })}
          </section>
          <div className="warning-container">
            Changing the organization owner can not be undone. After you
            transfer ownership you will no longer be able to invite members or
            change the organization owner.
          </div>
          <button
            className="button-tertiary"
            disabled={
              this.state.selectedUser.id === orgOwner.id ||
              this.state.modalButtonLoading
            }
            onClick={this.changeOwner}
          >
            {this.state.modalButtonLoading
              ? "Updating..."
              : "I understand, transfer this organization"}
          </button>
        </>
      </Modal>
    )
  }

  toggleOwnerModal = () => {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  render() {
    return (
      <>
        <section className="form-section" id="owner-modal-root">
          <h3>Organization owner</h3>
          <p>
            Only the organization owner can invite new members. The owner can
            also transfer ownership to another member.
          </p>
          <PlatformEditField
            title={`${this.props.orgOwner.login} ${
              this.props.isOwner() ? `(${this.props.orgOwner.email})` : ""
            } `}
            actions={[
              {
                icon: EditIcon,
                callback: this.toggleOwnerModal,
              },
            ]}
            fieldEnabled={this.props.members.length > 1 && this.props.isOwner()}
          />
        </section>
        {this.renderModal()}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    orgOwner: state.details.orgOwner,
  }
}

export default connect(mapStateToProps)(OrgOwnerField)

OrgOwnerField.propTypes = {
  orgOwner: PropTypes.object,
  currentUserId: PropTypes.string,
  isOwner: PropTypes.func,
  orgId: PropTypes.number,
  members: PropTypes.arrayOf(PropTypes.object),
  dispatch: PropTypes.func,
}
